import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { GET_USER_ABSENCE, REMOVE_USER_ABSENCE, SUBMIT_USER_ABSENCE, UPDATE_USER_ABSENCE, CLEAR_STUDENT_ABSENCE, GET_LEAVE_REQUESTS, GET_LEAVE_REQUEST, REVOKE_LEAVE_REQUEST } from 'actions/absence';
var INITIAL_STATE = {
  user: null,
  submitResult: null,
  leaveRequests: null,
  leaveRequest: null,
  revokeLeaveRequestResult: null
};
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case GET_USER_ABSENCE:
      return _objectSpread(_objectSpread({}, state), {}, {
        user: action.payload
      });
    case SUBMIT_USER_ABSENCE:
      return _objectSpread(_objectSpread({}, state), {}, {
        submitResult: action.payload
      });
    case UPDATE_USER_ABSENCE:
      return _objectSpread(_objectSpread({}, state), {}, {
        submitResult: action.payload
      });
    case REMOVE_USER_ABSENCE:
      if (state.user != null) {
        var foundIndex = state.user.findIndex(function (absence) {
          return absence.id == action.payload;
        });
        if (foundIndex > -1) {
          state.user.splice(foundIndex, 1);
        }
      }
      return state;
    case CLEAR_STUDENT_ABSENCE:
      return _objectSpread(_objectSpread({}, state), {}, {
        user: null
      });
    case GET_LEAVE_REQUESTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        leaveRequests: action.payload
      });
    case GET_LEAVE_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        leaveRequest: action.payload
      });
    case REVOKE_LEAVE_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        revokeLeaveRequestResult: action.payload
      });
    default:
      return state;
  }
}